import React from 'react';
import { Button, Props as ButtonProps } from './button';
import { createStyles } from '@/contexts/theme-context';
import { shadow } from '@/styles';
import { View } from 'react-native';

export type Props =
  | {
      children?: React.ReactNode;
    }
  | {
      buttonProps: ButtonProps;
      children?: React.ReactNode;
    };

export const Card: React.FC<Props> = (props) => {
  const [styles] = useStyles();
  return (
    <View style={styles.base}>
      <View style={styles.content}>
        {props.children}
        {'buttonProps' in props ? (
          <Button
            style={styles.bottomButton}
            type="tertiary"
            {...props.buttonProps}
          />
        ) : null}
      </View>
    </View>
  );
};

const useStyles = createStyles((theme) => ({
  base: {
    ...shadow({
      elevation: 5,
      opacity: 0.1,
      radius: 24,
      x: 0,
      y: 12,
    }),
    backgroundColor: theme.colors.white,
    borderRadius: 8,
  },
  bottomButton: {
    borderBottomWidth: 0,
    borderColor: theme.colors.stroke,
    borderLeftWidth: 0,
    borderRightWidth: 0,
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    borderTopWidth: 1,
  },
  content: {
    borderRadius: 8,
    overflow: 'hidden',
  },
}));
